"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var _index2 = require("../../helpers/index.js");
var UUID = _index.localStorageKeys.UUID;
var validateUUID = function validateUUID(event) {
  var uuid = event.xdm.web.webPageDetails._telus.userAccountID;
  if ((0, _index2.validateUserAccountID)(uuid)) {
    localStorage.setItem(UUID, uuid);
    return event;
  }
  delete event.xdm.web.webPageDetails._telus.userAccountID;
  return event;
};
var _default = exports["default"] = validateUUID;